export default __webpack_public_path__ + "static/media/GraphicDesign1.2c66dc62.png";